import React from "react";
import PropTypes from "prop-types";

const Plus = ({ className, color }) => {
  switch (color) {
    case `gold`:
      color = `#B08F57`;
      break;

    case `orange`:
      color = `#EC5B2D`;
      break;

    default:
      break;
  }

  return (
    <svg className={className} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.00024H20V11.0002H11V20.0002H9V11.0002H0V9.00024H9V0.000244141H11V9.00024Z"
        fill={color}
      />
    </svg>
  );
};

Plus.defaultProps = {
  className: ``,
  color: ``
};

Plus.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Plus;
